import { FC, useRef, useState } from "react";
import FormLayout from "../FormLayout";
import CustomInput from "../../_common/CustomInput";
import LoadingAnimation from "../../_common/Loading";
import tasksController, { IAddTaskDto } from "../../../Api/tasksController";
import { useToast } from "../../../hooks/useToast";
import { useModal } from "../../../hooks/useModal";

interface AddTaskFormProps {
    taskType: 'ideas' | 'todo' | 'inprogress' | 'done',
    columnName: string,
    onRefreshTasks: () => void,
}

const AddTaskForm: FC<AddTaskFormProps> = ({
    taskType,
    columnName,
    onRefreshTasks,
}) => {
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const toast = useRef(useToast()).current;
    const modal = useModal()

    const handleAddTask = async () => {
        if (loading) return;
        setLoading(true);
        const data: IAddTaskDto = {
            name: title,
            description: description,
            column: taskType,
        };
        const res = await tasksController.addTask(data);
        if (!res.ok) {
            toast.error(res.message);
            setLoading(false);
            return
        }
        toast.success(res.message);
        modal.close();
        onRefreshTasks();
    }


    const renderForm = () => {
        if (loading) return <LoadingAnimation />

        return (
            <>
                <CustomInput
                    label="Tytuł"
                    mode="text"
                    variant="filled"
                    sx={{ width: '100%' }}
                    value={title}
                    setValue={setTitle}
                />
                <CustomInput
                    label="Opis"
                    mode="multiline"
                    variant="filled"
                    sx={{ width: '100%' }}
                    value={description}
                    setValue={setDescription}
                />
            </>
        )
    }

    return (
        <FormLayout
            title={`Dodaj do ${columnName}`}
            onClickButton={handleAddTask}
        >
            {renderForm()}
        </FormLayout>
    )
}

export default AddTaskForm;